import { isValidString, isArray } from '../checkVarType';

/**
  * @desc checks if a string or an array contains a given value
  *
  * @param {string | array} x string or array to search in
  *
  * @param {any} y value to search for
  *
  * @returns {boolean} is y part of x?
*/
function includes(x, y) {
  if (
    isArray(x)
    || isValidString(x)
  ) {
    return x.indexOf(y) > -1;
  }
  return false;
}
export default includes;
